module.exports = __webpack_public_path__ + "static/media/StarWhiteFilled.2d43aacf.svg";